import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface IGlobalModals {
  visibilityState: "init" | "ready" | "blocked";
}

const initialState: IGlobalModals = {
  visibilityState: "init",
};

export const globalModalsSlice = createSlice({
  name: "global/modals",
  initialState,
  reducers: {
    /**
     * Позволяет отключить компонент GlobalModals из любого места приложения.
     * @description apps/next-app/src/layouts/GlobalModals.tsx
     * @example
     * const dispatch = useAppDispatch();
     * dispatch(api.global.modals.setGlobalModalsShowStatus("blocked"));
     */
    setGlobalModalsShowStatus: (
      state: IGlobalModals,
      action: PayloadAction<IGlobalModals["visibilityState"]>
    ) => {
      state.visibilityState = action.payload;
    },
  },
});

/**
 * test
 */
export const { setGlobalModalsShowStatus } = globalModalsSlice.actions;

export default globalModalsSlice.reducer;
